import { type ApolloClient } from '@apollo/client'
import { type GetStaticPropsContext } from 'next'
import { REVALIDATE_INTERVAL_IN_SECONDS } from 'constants/common'
import { PublicExpertDetailSharedHeaderDocument } from 'types/graphql-generated'
import { initializeApollo } from 'utils/apolloClient'
import { addError } from 'utils/rum'

export const prepareGetExpertStaticProps = async (
  context: GetStaticPropsContext,
  {
    expertId,
  }: {
    expertId: string
  },
  inputApolloClient?: ApolloClient<any>
) => {
  try {
    const apolloClient = inputApolloClient || initializeApollo()
    const query = PublicExpertDetailSharedHeaderDocument

    if (expertId) {
      await apolloClient.query({
        query,
        variables: {
          id: expertId,
        },
      })
    }

    return apolloClient
  } catch (error) {
    addError(error)
    return {
      notFound: true,
      props: { slug: null, navigation: [], breadcrumbs: [] },
      revalidate: REVALIDATE_INTERVAL_IN_SECONDS,
    }
  }
}
